import MonacoEditor from "@monaco-editor/react";
import { loader } from "@monaco-editor/react";

loader.config({ paths: { vs: "/vs" } });

export { MonacoEditor };
